import { render, staticRenderFns } from "./ListGatewayShipment.vue?vue&type=template&id=197cef0a&"
import script from "./ListGatewayShipment.vue?vue&type=script&lang=js&"
export * from "./ListGatewayShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports